export default "__VITE_ASSET__f6da3641__"